import React, { useState } from 'react';
import Loader from './components/Loader/Loader';
import './App.css';
import StartPage from './components/StartPage/StartPage';
import Navbar from './components/Navbar/Navbar';
import GamePage from './components/GamePage/GamePage';
import WellDone from './components/WellDone/WellDone';
import SunPage from './components/SunPage/SunPage';
import SentencePage from './components/SentencePage/SentencePage';
import InfoPage from './components/InfoPage/InfoPage';
import FinishPage from './components/FinishPage/FinishPage';
import textContents from './data/dataInterface';

let imagesName = {}; //массив с названиями картинок в порядке следования
let imagesArr = {}; //массив с картинками, ключ - название картинки
let isLoad = false;
let langv = 'rus';
   
let addWords = []; //массив всех слов игры
let gameWords = []; //слова, которые будут расположены на текущем экране
let answerWords = []; //массив с координатами текущих слов-ответа, расположенных внизу
let resultArray = {}; //массив результатов
let num = 0;

//чтение в кэш картинок контента, ключ - название картинки
function GameContent(content, callback)
{
    resultArray = [];
    imagesName = Object.keys(content);
    let i= 0;
    for(let id of imagesName)
    {
        let slovaRus = content[id].rus.split(' ');
        let slovaFin = content[id].fin.split(' ');
        resultArray.push({
           id: i,
           fin: slovaFin.length,   //количество слов в ответе
           rus: slovaRus.length,
           answer: 0,               //количество правильных ответов на поле
           ready: false
        });
        i++;
    };
    for(let id of imagesName)		//загрузка в кэш картинок
    {
        let urlFile = process.env.PUBLIC_URL + '/content/' + id + '.jpg';
        imagesArr[id] = new Image(550,450);
        imagesArr[id].src = urlFile;
    }
    ;
    imagesArr['bgGame'] = new Image(700,650);
    imagesArr['bgGame'].src =
            process.env.PUBLIC_URL + '/Interface/background.jpg';
	imagesArr['bgStart'] = new Image(700,650);
    imagesArr['bgStart'].src =
        process.env.PUBLIC_URL + '/Interface/backgroundStart.jpg';
	imagesArr['bgInfo'] = new Image(700,650);
    imagesArr['bgInfo'].src =
        process.env.PUBLIC_URL + '/Interface/backgroundInfo.jpg';
    imagesArr['WellDone'] = new Image(700, 650);
    imagesArr['WellDone'].src =
        process.env.PUBLIC_URL + '/Interface/WellDone.jpg';
    imagesArr['FinishPage'] = new Image(700, 650);
    imagesArr['FinishPage'].src =
        process.env.PUBLIC_URL + '/Interface/FinishPage.jpg';
    callback();
};
  function newResult() {
	  for(let i = 0; i < resultArray.length; i++) {
		resultArray[i].answer = 0;
		resultArray[i].ready = false;
	  };
  };
//создание массива всех слов игры без текущих слов
function allWords(content, id, lang,callback) {
    let arr =  [];
    for(var key in content) { 
        if(id === key) continue; //исключаем выбранное предложение
		let array = content[key][lang].split(' '); //слова одного предложения
        for(var value in array) {
            arr.push(array[value]); //создание массива всех дополнит. слов 
        }
      };
    addWords = arr.filter((elem,pos) => {  //убираем повторяющиеся значения
        return arr.indexOf(elem) === pos;}
    );
    shuffle(addWords);  //перемешиваем массив дополнит. слов
		
	callback();
    }

//определение позиций ответа
function positionWords(dataCont,wordId,langv) {
    answerWords  = [];
    gameWords = [];
	let selectedWords = dataCont[wordId][langv];
    let array = selectedWords.split(' '); //слова предложения-ответа
    for (let i = 0; i < array.length; i++) {  //определяем координаты и ключи для полей ответа
        let answerKey = wordId + langv + i;
        let widthWord = (array[i].length) * 17;
        answerWords.push({
            id: i,
            answerKey: answerKey,
            words: array[i],
            fake: false,
            widthWord: widthWord
        });     
    }

}


 // словa правильные и дополнительные, позиции 
function askWords(){
    gameWords = [];
    for(let i = 0;i < answerWords.length;i++)
        gameWords.push(answerWords[i]);
    let key = answerWords.length;
    var answerCount = 10 - key;
	let i = 0;
	while(i < answerCount){
		let doble = false;
		for(let j = 0;j < answerWords.length;j++) {
			if(addWords[i] === answerWords[j].words) {
				doble = true;
				break;
			}
		}
		if(!doble) {
			let widthWord = (addWords[i].length) * 17;
			let  fake = 'fake' + i;
			gameWords.push({
				id:key,
				answerKey:fake,
				words: addWords[i],
				fake:true,
				widthWord: widthWord
				});
			key++;
		};
		i +=1;
    }
    suffleScreen();
   // priReady = true;
 }

function suffleScreen() {
    for (let i = 0; i < gameWords.length; i++) {
        let side = Math.floor(Math.random() * 2) ;    //выбираем на какой стороне будет слово
        newPosition(gameWords[i], side);
        let found = founding(i,side);
        if (side === 1) side = 0; else side = 1;
        while(found) found = founding(i,side);
    }  
}

function founding(i,side) { //нахождение занятого места
    
    let found = false;
    for(let j = 0; j < i; j++) {
        if(gameWords[i].y === gameWords[j].y ) {
                found = true;
                newPosition(gameWords[i], side);
        }
    }
    return found;
}
function newPosition(word, side) {
    let PositionX, PositionY;
    if (side  === 1) {
        PositionX = 310 - word.widthWord - Math.floor(Math.random() * 30);
        PositionY = Math.floor(Math.random() * 7) * 50 + 95;
    }
    else {
        PositionX = Math.floor(Math.random() * 30 - 320);
        PositionY = Math.floor(Math.random() * 7) * 50 + 80;
    }
        word.x = PositionX;
        word.y = PositionY;       
}


//Функции перемешивания масива

//вспомогательная функция
function putToCache(elem, cache){
	if(cache.indexOf(elem) !== -1){
		return;
	}
	var i = Math.floor(Math.random()*(cache.length + 1));
	cache.splice(i, 0, elem);
}
//функция, возвращающая свеженький, девственный компаратор
function madness(){
	var cache = [];
	return function(a, b){
		putToCache(a, cache);
		putToCache(b, cache);
		return cache.indexOf(b) - cache.indexOf(a);
	};
}
//собственно функция перемешивания
function shuffle(arr){
	var compare = madness();
	return arr.sort(compare);
 };       

function readData()  //чтение данных 
{
     //определение языка страницы сайта на котором находится игра по нахождению в адресе fin
    let address = window.top.document.location.href;
    if(address.indexOf('/fin/') > 0) langv = 'fin';
    
    GameContent(textContents.content, function () { isLoad = true; });
    let selectedImg = imagesName[0];
    positionWords(textContents.content, selectedImg, langv);
    allWords(textContents.content, selectedImg, langv, askWords);
	
};

readData();



function App()
{

    const [isLoading,setIsLoading] = useState(false);  //окно1,признак загрузки контента

    const [lang,setLang] = useState(langv);             //установка текущего языка
    const [start, setStart] = useState(false);          //окно2,начало игры с нуля, выбор языка
    const [step, setStep] = useState(0);                //номер картинки по порядку
    const [imgId, setImgId] = useState('');             //наименование текущей картинки
	
	const [isInfo, setIsInfo] = useState(false);		//окно3, инструкция к игре
	const [isSun, setIsSun] = useState(false);			//окно4, вращающееся солнце
	const [isSentence, setIsSentence] = useState(false);//окно5, картинка и текущее предложение
	const [isGame, setIsGame] = useState(false);		//окно6, слова-вопросы и поля ответов
	const [isWellDone, setIsWellDone] = useState(false);//окно7, солнышко плюс МОЛОДЕЦ
	const [isRetell, setIsRetell] = useState(false);	//окно8, Слова поощрения и призыв пересказать
	const [isNavbar, setIsNavbar] = useState(false);	//окно9, верхнее меню
	
	const [isNewImg, setIsNewImg] = useState(false);
    const [result, setResult] = useState(false);  //результат 

    //Проверка загрузился ли контент или продолжаем показывать Preloader
    function preloadTime() {
        if (isLoad && num === 0)
		for(let i = 0; i < 4; i++) {
			if(num > 0) break;

			{
				setIsLoading(true);
				setImgId(imagesName[0]);
				setStart(true);
				num ++;
				break;
			}
			setTimeout(setIsLoading,2000,isLoad);
		}
    };
    setTimeout(preloadTime,5000);
	
//если язык изменился
function newDate(dataCont, curImgId, curLangv) {
     positionWords(dataCont,curImgId,curLangv);
    allWords(dataCont, curImgId, curLangv, askWords);

}
     
    //Реакция на нажатие клавиш в игре
    const handleComponent = ((pri)=>{
        if(pri === 'rus' && lang === 'fin') {
            setLang('rus');
            langv = lang;
            console.log('resultArray[step].ready', resultArray[step].ready, 'step = ', step);
            if (!isSentence) {
                newDate(textContents.content, imagesName[step], pri);
                resultArray[step].answer = 0;
            }
        }
        if(pri === 'fin' && lang === 'rus') {
            setLang('fin');
            langv = lang;
            console.log('resultArray[step].ready', resultArray[step].ready, 'step = ', step);
            if (!isSentence) {
                newDate(textContents.content, imagesName[step], pri);
                resultArray[step].answer = 0;
            }
        }
        if(pri === 'start')
        {
            setStart(false);
            setImgId(imagesName[0]);
            setStep(0);
			setIsInfo(true);
			setIsNavbar(true);
		}
		if(pri === 'continue') {
			setIsInfo(false);
			setIsSun(true);
			setTimeout((() => {
				setIsSun(false);	
                setIsGame(true);
			}), 6000);
		}
		if(pri === 'info') {
			setIsInfo(true);
			setIsGame(false);
			setIsSentence(false);
		}
        if(pri === 'answer')
        {
           resultArray[step].answer +=1; 
           setIsNewImg(false);
           if(resultArray[step].answer === resultArray[step][lang]) {
                resultArray[step].ready = true;
                setResult(true);
            }
        }
          if(pri === 'next')
        {
			setIsGame(false);
			setIsWellDone(true);
			if((step+1) < resultArray.length ) {
			setImgId(imagesName[step+1]);
            setStep(step+1);
			setResult(false);
			newDate(textContents.content,imagesName[step+1], lang)
			
			setTimeout((() => {
				setIsGame(true);
				setIsWellDone(false);
			}), 3000)
			}
			else {
				setTimeout((() => {
				setIsRetell(true);
				setIsWellDone(false);
			}), 5000)
			}
        }
		if(pri ==='prev')
        {
            if (resultArray[step].answer !== resultArray[step][lang]) resultArray[step].answer = 0;

			setIsGame(false);
			setIsSentence(true);
			setImgId(imagesName[step-1]);
            setStep(step-1);
		}
		if(pri === 'nextSentence')
		{
			setImgId(imagesName[step+1]);
			setStep(step+1);
			if(!resultArray[step+1].ready) {
				setIsGame(true);
                setIsSentence(false);
                newDate(textContents.content, imagesName[step + 1], lang);
                resultArray[step+1].answer = 0;
			}
		}
		if(pri === 'newGame') {
			setIsRetell(false);
			newResult();
			setResult(false);
			newDate(textContents.content,imagesName[0], lang)
			setStep(0);
			setImgId(imagesName[0]);
			setIsGame(true);
		}
		if(pri === 'toStart') {
			newResult();
			setResult(false);
			newDate(textContents.content,imagesName[0], lang)
			setStep(0);
			setImgId(imagesName[0]);
			setIsGame(false);
			setIsSentence(false);
			setIsWellDone(false);
			setIsRetell(false);
			setIsInfo(false);
			setStart(true);
		}
    });

    return (
        <div className="App">

            {!isLoading ? <Loader /> : null}
			{isNavbar ?  <Navbar lang= {lang} onClick = {(pri)=>handleComponent(pri)} 
								topMenu = {textContents.topMenu} /> : null}

            {isSun ? <SunPage src={imagesArr['bgInfo'].src} value = {textContents.textGame.SunText[lang]} /> : null}
			{start ? <StartPage lang= {lang} src={imagesArr['bgStart'].src} 
					onClick = {(pri)=>handleComponent(pri)} 
					startPage = {textContents.startPage}  /> : null}
			{isInfo ? <InfoPage lang= {lang} onClick = {(pri) => handleComponent(pri)} textGame = {textContents.textGame} src={imagesArr['bgInfo'].src}/> : null }

			{isGame ? <GamePage step = {step}  
					curSentens = {textContents.content[imgId][lang]} 
					topMenu = {textContents.topMenu.GameQuestion[lang]} imgName = {imgId} 
                src={imagesArr[imgId].src} 
                srcBg={imagesArr['bgInfo'].src}
					onClick = {(pri)=>handleComponent(pri)}  
					NewImg = {isNewImg}
					answers = {answerWords} 
					gameWords = {gameWords}
					levelReady = {result} /> : null}

            {isWellDone ? <WellDone src={imagesArr['WellDone'].src} textGame={textContents.textGame.GameOver[lang]} /> : null}
			{isSentence ? <SentencePage step = {step}  
				curSentens = {textContents.content[imgId][lang]}  
				topMenu = {textContents.topMenu.GameQuestion[lang]} imgName = {imgId} 
                src={imagesArr[imgId].src} 
                srcBg={imagesArr['bgInfo'].src}
                onClick={(pri) => handleComponent(pri)} /> : null}
            {isRetell ? <FinishPage lang={lang} onClick={(pri) => handleComponent(pri)} textGame={textContents.textGame} src={imagesArr['FinishPage'].src} /> : null}

        </div>
        );
}

export default App;
